import useLocalStorageSelect from "../hooks/useLocalStorageSelect";
import Select from "react-select";
import teamsBasic from "../data/teamsBasic2025.json";
import { GetQB1 } from "../hooks/getDepthCharts.js";
import { GetTeamSched } from "../hooks/getTeamSched.js";
import { getBye, GetTeamRecord } from "../hooks/getTeamData.js";
import { darkTeams } from "../hooks/vars.js";

function TeamSchedule(props) {
  // props: id=1

  // Get list of NFL teams for dropdown
  const teams = teamsBasic
    .sort((a, b) => {
      if (a.FullName < b.FullName) {
        return -1;
      } else {
        return 1;
      }
    })
    .map((data) => ({
      value: data.Key,
      label: data.FullName,
    }));

  const [teamDropdown, setTeamDropdown] = useLocalStorageSelect(
    "teamDropdown" + props.id,
    teams[0],
    teams
  );

  const [showPreseason, setShowPreseason] = useLocalStorageSelect(
    "showPreseason" + props.id,
    false,
    [true, false]
  );

  function preseasonToggleHelper() {
    setShowPreseason(!showPreseason);
  }

  // Find team data for both dropdowns with safety checks
  const teamData = teamsBasic.find((t) => t.Key === teamDropdown?.value);
  //console.log("teamSched.js bye: " + byeWeek)
  const darkTeam = darkTeams.includes(teamData.Key);
  const teamLogo = teamData?.WikipediaLogoURL;

  const byeWeek = getBye(teamData?.Key);
  //console.log(byeWeek)

  const Color1 = "#" + teamData?.PrimaryColor;
  const Color2 = "#" + teamData?.SecondaryColor;
  const Color3 = "#" + teamData?.TertiaryColor;
  //const Color4 = "#" + teamData?.QuaternaryColor;

  return (
    <>
      <div
        className="defaultModal"
        style={{
          borderColor: Color2,
          background:
            "linear-gradient(to bottom right, " +
            Color1 +
            " 50%, #000 150%)",
        }}
      >
        <div className={"teamScheduleContainer " + teamData.Key}>
          <div>
            <Select
              options={teams}
              onChange={setTeamDropdown}
              value={teamDropdown}
              placeholder="Select Team..."
              className="teamDropdown"
            />
          </div>

          <div
            className="teamInfo"
            style={{
              color: !darkTeam
                ? Color2
                : Color3,
              padding: "1%",
            }}
          >
            <div>
              <div>
                HC: <strong>{teamData?.HeadCoach || "N/A"}</strong>
              </div>
              <div>
                QB1:{" "}
                <strong>
                  <GetQB1 k={teamData.Key} p="QB1" />
                </strong>
              </div>
            </div>
            <div>
              <div>
                OC: <strong>{teamData?.OffensiveCoordinator || "N/A"}</strong>
              </div>
              <div>
                DC: <strong>{teamData?.DefensiveCoordinator || "N/A"}</strong>
              </div>
            </div>

            <div className="teamRecord">
              <GetTeamRecord t={teamData.Key} />
            </div>
          </div>
          <div className="schedWrap">
            <div
              className="schedGridRow rowTitle"
              style={{
                background: "none",
                color: "#" + teamData.TertiaryColor,
              }}
            >
              <div>
                <strong>Wk</strong>
              </div>
              <div>
                <strong>Date</strong>
              </div>
              <div>
                <strong>Opponent</strong>
              </div>
              <div>
                <strong>Score</strong>
              </div>
              <div>
                <strong>Result</strong>
              </div>
            </div>
            <GetTeamSched t={teamData.Key} ps={showPreseason} bye={byeWeek} />

            <button className="toggleButton" onClick={preseasonToggleHelper}>
              Toggle Preseason {showPreseason}
            </button>
          </div>
        </div>
        <div
          className="teamLogoContainer"
          style={{ backgroundImage: "url(" + teamLogo + ")" }}
        ></div>
      </div>
    </>
  );
}

export default TeamSchedule;
